import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { invoiceTemplateSchema } from './schemas';
import { invoiceTemplateQueryOptions } from './useInvoiceTemplate';

export const useUnpauseInvoiceTemplate = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data: invoiceTemplate } = await fetchJson(`/invoice-templates/${id}/unpause`, {
        method: 'POST',
        schema: apiResourceSchema(invoiceTemplateSchema),
      });

      return invoiceTemplate;
    },
    onSuccess: (invoiceTemplate) => {
      queryClient.setQueryData(invoiceTemplateQueryOptions(invoiceTemplate.id).queryKey, invoiceTemplate);
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoiceTemplates.show.id(id) });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoiceTemplates.index.root });
    },
  });
};
